export const sanitizeHTML = (html: string, clickable = true) => {
  const template = document.createElement('template')

  template.innerHTML = html

  const scripts = template.content.querySelectorAll('script')

  scripts.forEach((script) => script.remove())

  const elements = template.content.querySelectorAll('*')

  elements.forEach((element) => {
    const attributes = Array.from(element.attributes)

    attributes.forEach((attribute) => {
      if (
        /^on/i.test(attribute.name) ||
        attribute.value.includes('javascript:')
      ) {
        element.removeAttribute(attribute.name)
      }
    })
  })

  const anchors = template.content.querySelectorAll('a')

  anchors.forEach((anchor) => {
    const href = anchor.getAttribute('href')

    if (href?.startsWith('/')) {
      anchor.setAttribute('href', `https://onlyfans.com${href}`)
      anchor.setAttribute('target', '_blank')
    }

    if (!clickable) {
      anchor.removeAttribute('href')
      anchor.removeAttribute('target')
    }

    // Prevent default behavior
    if (!clickable) {
      anchor.onclick = (event) => {
        event.preventDefault()
        event.stopPropagation()
      }
    }
  })

  return template.innerHTML
}
